import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Typography, Grid, makeStyles } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { RenderGate } from '@heeros/react-sdk'

import LoginForm from './LoginForm'
import AlertBox from './AlertBox'

import ModularLogo from '../../assets/modular_logo_small_black.svg'

const useStyles = makeStyles(theme => ({
  infoBoxContainer: {
    padding: theme.spacing(1.5, 0)
  },
  successAnimation: {
    transform: 'scale(1)',
    backfaceVisibility: 'hidden',
    animation: '$grow 0.2s cubic-bezier(.36,.07,.19,.97) both'
  },
  '@keyframes grow': {
    '0%': { transform: 'scale(1) rotate(0deg)' },
    '50%': { transform: 'scale(1.05) rotate(2deg)' },
    '100%': { transform: 'scale(1) rotate(0deg)' }
  },
  rootContainer: {
    minHeight: '300px',
    maxWidth: '410px'
  },
  modularLogo: {
    height: '50px',
    display: 'block',
    margin: '0 auto',
    paddingBottom: theme.spacing(5) + 'px'
  },
  titleText: {
    paddingBottom: theme.spacing(1) + 'px'
  }
}))

const LoginView = props => {
  const classes = useStyles()
  const { t } = useTranslation()
  return (
    <Grid container direction='column' className={classes.rootContainer} alignItems='center'>
      <img src={ModularLogo} alt='Modular' className={classes.modularLogo} style={{ display: 'block', margin: '0 auto' }} />
      <Typography variant='h5' className={classes.titleText}>{t('loginView.titleText')}</Typography>
      <RenderGate shouldRender={props.passwordResetCompleted}>
        <Grid item className={classNames(classes.infoBoxContainer, classes.successAnimation)}>
          <AlertBox
            severity='success'
            elevation={1}
            message={t('loginView.passwordSuccessfullyReset')}
            dataTest='passwordResetSuccessInfoBox'
          />
        </Grid>
      </RenderGate>
      <RenderGate shouldRender={props.passwordResetRequested}>
        <Grid item className={classNames(classes.infoBoxContainer, classes.successAnimation)}>
          <AlertBox
            severity={props.passwordResetMessageSeverity}
            elevation={1}
            message={t(props.passwordResetMessage)}
            dataTest='passwordResetEmailSentInfoBox'
          />
        </Grid>
      </RenderGate>
      <RenderGate shouldRender={props.userUnauthorized}>
        <Grid item className={classes.infoBoxContainer}>
          <AlertBox
            severity='warning'
            message={t('loginView.unauthorizedUser')}
            dataTest='unauthorizedUserInfoBox'
          />
        </Grid>
      </RenderGate>
      <RenderGate shouldRender={props.hasError}>
        <Grid item className={classes.infoBoxContainer}>
          <AlertBox
            elevation={1}
            variant='filled'
            severity='error'
            message={props.hasError === 'TooManyAttemptsError' ? t('loginView.tooManyAttempts') : t('loginView.invalidCredentials')}
            dataTest='loginErrorInfoBox'
          />
        </Grid>
      </RenderGate>
      <LoginForm {...props} />
    </Grid>
  )
}

LoginView.propTypes = {
  hasError: PropTypes.string.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  handleLoginSubmit: PropTypes.func.isRequired,
  userUnauthorized: PropTypes.bool.isRequired
}

export default LoginView
